export default "__VITE_ASSET__296e5a8f__"